'use client'

 // Error components must be Client Components
/***
 *
 * @file app/error.tsx
 * @description Error page is used to show error message.
 * @author Naveen Kumar
 * @organization Ingka Center
 * @since 13 Feb 2024
 *
 */

import CustomError from "@/components/CustomError"

const Error = ({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) => {
  return (
    <CustomError 
      // heading={t('heading')} 
      // content={t('content') || error?.message || ''}
      // buttonLabel={t('buttonLabel')}
      
      heading={"Oops! Something went wrong!"} 
      content={"We are working hard to solve the problem, try again or check back soon."}
      buttonLabel={"Try again"}
      // link={{url: "/", label: "Back to home"}}
      onClick={reset} 
      />
  )
}

export default Error;